import { typeColorCondition } from "./constants";
import styled from "styled-components";
import { At, Phone, Envelope, Truck, ChatText } from "phosphor-react";

const Container = styled.div`
  padding: 10px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const Name = styled.div`
  font-size: 2.5rem;
  font-weight: 900;
`;

const Type = styled.div`
  display: flex;
  align-items: center;
  font-weight: 900;
  font-size: 0.8rem;
  text-transform: uppercase;
  color: ${({ color }) => color};
  div {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border-style: solid;
    border-width: 2px;
    border-color: ${({ color }) => color};
    background-color: rgba(0, 0, 0, 0);
    margin-right: 5px;
  }
`;

const Detail = styled.div`
  color: var(--grey);
  font-size: 0.8rem;
  font-weight: 500;
  display: flex;
  margin-bottom: 10px;
  svg {
    margin-right: 10px;
  }
`;

const MainView = ({ storedContact, handleClickContactType }) => {
  const {
    firstName,
    lastName,
    contactType,
    email,
    phoneNumber,
    mailingStreetAddress,
    mailingCity,
    mailingRegion,
    mailingZipCode,
    mailingCountry,
    deliveryStreetAddress,
    deliveryCity,
    deliveryRegion,
    deliveryZipCode,
    deliveryCountry,
    description,
  } = storedContact;
  return (
    <Container>
      <Header>
        <Name>
          {firstName} {lastName}
        </Name>
        <Type
          color={typeColorCondition[contactType]}
          onClick={handleClickContactType}
        >
          <div></div>
          {contactType}
        </Type>
      </Header>
      <Detail>
        <At size={20} /> {email}
      </Detail>
      <Detail>
        <Phone size={20} />
        {phoneNumber}
      </Detail>
      <Detail>
        <Envelope size={20} />
        {mailingStreetAddress} {mailingCity} {mailingRegion} {mailingZipCode}{" "}
        {mailingCountry}
      </Detail>
      <Detail>
        <Truck size={20} />
        {deliveryStreetAddress} {deliveryCity} {deliveryRegion}{" "}
        {deliveryZipCode} {deliveryCountry}
      </Detail>
      <Detail>
        <ChatText size={20} />"{description}"
      </Detail>
    </Container>
  );
};

export default MainView;
